import ApiStatus from "../constants/api-status.enum";
import { LoginModalConstant } from "../constants/login-modal.constant";

export default class LoginModalService {
    static disableButton(checkUserApiStatus, generateOtpApiStatus, loginFormValidated) {
        if(checkUserApiStatus === (ApiStatus.LOADING || ApiStatus.SUCCESS) || generateOtpApiStatus === ApiStatus.LOADING) {
            return true;
        }
        else {
            return (this.checkFormValidation(loginFormValidated)) ? false: true;
        }
    }

    static getButtonValue(checkUserApiStatus, generateOtpApiStatus) {
        if(checkUserApiStatus === (ApiStatus.LOADING || ApiStatus.SUCCESS) || generateOtpApiStatus === ApiStatus.LOADING) {
            return LoginModalConstant.SENDING_OTP;
        }
        else {
            return LoginModalConstant.GET_OTP;
        }
    }

    static getButtonValueV2(checkUserApiStatus, generateOtpApiStatus) {
        if(checkUserApiStatus === (ApiStatus.LOADING || ApiStatus.SUCCESS) || generateOtpApiStatus === ApiStatus.LOADING) {
            return LoginModalConstant.SENDING_OTP;
        }
        else {
            return LoginModalConstant.GET_OTP_V2;
        }
    }

    static checkFormValidation(loginFormValidated) {
        return loginFormValidated ? true : false;
    }

    static validateMobileNumber(mobileNumber) {
        const regexForOnlyNumber = /^\d{10}$/;
        if (mobileNumber.match(regexForOnlyNumber)) {
            return true;
        }
        return false;
    }
}